import { z } from 'zod';

var AllowedWallets = {
  all: '*',
  injected: 'metamask',
  walletconnect: 'walletconnect',
  keplr: 'keplr',
  templewallet: 'templewallet',
  // or
  lens: 'lens',
  ud: 'ud',
  cyberconnect: 'cyberconnect'
};
var reactions = ['😂', '😢', '😦', '😍', '🤔', '👀', '🙌', '👍', '👎', '🔥', '🍻', '🚀', '🎉', '❤️', '💯'];
var ClientConfigSchema = z.object({
  background: z.string().optional(),
  gradientAndMesh: z["boolean"]().optional(),
  redirectUrlOnLeave: z.string().optional(),
  wallets: z.array(z["enum"](['*', 'metamask', 'walletconnect', 'keplr', 'templewallet', 'lens', 'ud', 'cyberconnect', 'phantom'])).optional()
});

export { AllowedWallets, ClientConfigSchema, reactions };
